import Vue              from 'vue'
import Router           from 'vue-router'
import ElementUI        from 'element-ui'
import locale           from 'element-ui/lib/locale/lang/es'
import VueCookies       from 'vue-cookies'
import Vuetify          from 'vuetify'

import '@fortawesome/fontawesome-free/css/all.css'
import './plugins/vuetify'
import 'element-theme-default';
import 'vuetify/dist/vuetify.min.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'


import App                      from './App'
import Aulas                    from '@/components/Aulas'
import Capacitacion             from '@/components/Capacitacion'
import Capacitaciones           from '@/components/Capacitaciones'
import Congreso                 from '@/components/Congreso'
//import CongresoEv               from '@/components/CongresoEv'
import CongresoRec              from '@/components/CongresoRec'
import Cuestionario             from '@/components/Cuestionario'
import CuestionarioRespuestas   from '@/components/Cuestionario_Respuestas'
import Cuestionarios            from '@/components/Cuestionarios'
import Datos                    from '@/components/Datos'
import Editar                   from '@/components/Editar'
import Home                     from '@/components/Home'
import Login                    from '@/components/Login'
import Mensaje                  from '@/components/Mensaje'
import Mensajes                 from '@/components/Mensajes'
//import Pautas                   from '@/components/Pautas'
import Pass                     from '@/components/Pass'
import Recuperar                from '@/components/Recuperar'
import RecuperarCampus          from '@/components/RecuperarCampus'
//import Registro                 from '@/components/Registro'
import Actualizar               from '@/components/Actualizar'


Vue.config.productionTip = false
Vue.use(ElementUI, { locale })
Vue.use(VueCookies)
Vue.use(Vuetify)
Vue.use(Router)


const router = new Router({
    mode: 'history',
    routes: [
        {   path: '/login',                         name: 'login',                      component: Login
        },
        {   path: '/aulas',                         name: 'aulas',                      component: Aulas,
        },
        {   path: '/comision/:id',                  name: 'capacitacion',               component: Capacitacion,
        },
        {   path: '/capacitaciones',                name: 'capacitaciones',             component: Capacitaciones,
        },
        {   path: '/congreso',                      name: 'congreso',                   component: Congreso,
        },
        {   path: '/cuestionario/:id',              name: 'cuestionario',               component: Cuestionario,
        },
        {   path: '/cuestionario_respuestas/:id',   name: 'cuestionario_respuestas',    component: CuestionarioRespuestas,
        },
        {   path: '/cuestionarios',                 name: 'cuestionarios',              component: Cuestionarios,
        },
        {   path: '/datos',                         name: 'datos',                      component: Datos,
        },
        {   path: '/editar/:id',                    name: 'editar',                     component: Editar,
        },
        {   path: '/home',                          name: 'home',                       component: Home,
        },
        {   path: '/mensaje/:id',                   name: 'mensaje',                    component: Mensaje,
        },
        {   path: '/mensajes/:id',                  name: 'mensajes',                   component: Mensajes,
        },
        /*{   path: '/pautas',                        name: 'pautas',                     component: Pautas,
        },*/
        {   path: '/pass',                          name: 'pass',                       component: Pass,
        },
        {   path: '/recuperar',                     name: 'recuperar',                  component: Recuperar,
        },
        {   path: '/recuperar_campus',              name: 'recuperar_campus',           component: RecuperarCampus,
        },
       /* {   path: '/registro',                      name: 'registro',                   component: Registro,
        },*/
       {   path: '/validar_datos',                 name: 'actualizar',                 component: Actualizar,
        },
        {   path: '',                               redirect: '/login',
        },
        {   path: '*',                              redirect: '/login',
        }
    ]
})



new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
